import React, {Component} from 'react'
import {defineMessages, injectIntl} from 'react-intl'
import Select from 'react-select'

const messages = defineMessages({
    "seller_email": {
        id: 'from.email_selection.seller_email',
        defaultMessage: 'Seller Email',
    },
    "company_email": {
        id: 'from.email_selection.company_email',
        defaultMessage: 'Company Email',
    },
    "location_email": {
        id: 'from.email_selection.location_email',
        defaultMessage: 'Location Email',
    },
    "template_email": {
        id: 'from.email_selection.template_email',
        defaultMessage: 'Template Email',
    },
    "hide_email": {
        id: 'from.email_selection.hide_email',
        defaultMessage: 'Hide',
    }
})

class FromEmailSelect extends Component {

    constructor(props, context) {
        super(props, context)
        const options = [
            {
                value: 'template',
                label: this.props.intl.formatMessage(messages["template_email"])
            },
            {
                value: 'company',
                label: this.props.intl.formatMessage(messages["company_email"])
            },
            {
                value: 'location',
                label: this.props.intl.formatMessage(messages["location_email"])
            },
            {
                value: 'seller',
                label: this.props.intl.formatMessage(messages["seller_email"])
            },
            {
                value: 'hide',
                label: this.props.intl.formatMessage(messages["hide_email"])
            },
        ]
        const optionFound = options.find(option => option.value === this.props.value)
        this.state = {
            options: options,
            selectedOption: optionFound || options[3]
        }
        const defaultCallback = () => {}
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.onChange(selectedOption.value)
        this.setState({
            selectedOption: selectedOption,
        });
    }

    render() {
        return (
            <Select
                name={this.name}
                searchable={false}
                multi={false}
                placeholder={this.placeholder}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={false}
            />
        )
    }
}

export default injectIntl(FromEmailSelect)





// WEBPACK FOOTER //
// ./src/template/sections/content/document-info/fromemailselection.component.jsx